
import React, { Component } from 'react';

class ChildrensMinistry extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Children's Ministry</h1>
          </div>
        </header>
        <section className="container">
          <p className="lead"><strong>Kidz Biz & Children's Church</strong></p>
          <p>
            On Sunday mornings we offer two, age-appropriate children’s ministries: Children’s Church (prep and kinder) and Kidz Biz (school grades 1 to 4). We also offer a crèche and ‘cry room’ for very small children.
          </p>

          <p>
            All of our programs are run by trained and child-safety accredited leaders, and are tailored to teach children biblical truths in age-appropriate ways, using stories, songs, games and other activities to make learning the Bible fun and accessible for all children.
          </p>

          <p>
            During church services we also have a regular children’s talk which focuses on what the main point of the pastors sermon will be, and presents it in a simpler, child friendly way.</p>
          <p>
            We would love to welcome your kids, and have them join us in our Kids Ministries! Children will leave church to join these ministries about half way through the service.  Please come down with them, and meet one of our friendly Kids Ministry leaders.
          </p>

          <p>
            Organisers:
            <ul>
              <li>Kidz Biz: Simone Betlehem</li>
              <li>Children's Church: Moni Ridge</li>
              <li>Creche: Simone Betlehem</li>
            </ul>
          </p>
        </section>
      </section>
    );
  }
}

export default ChildrensMinistry;
